import { render } from "./VUEInputUtenti.vue?vue&type=template&id=2d8368ea"
import script from "./VUEInputUtenti.vue?vue&type=script&lang=js"
export * from "./VUEInputUtenti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__